import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Connects to data-controller="notice-modal"
// Cookieキーがあるお知らせだけ、表示済み状態を端末に記録する
export default class extends Controller {
  static values = {
    cookieKey: String
  }

  connect() {
    this.cleanupBackdrops()
    this.modal = Modal.getOrCreateInstance(this.element)

    if (this.hasCookieKeyValue) {
      if (this.cookieExists()) return

      this.markAsShown()
    }

    this.modal.show()
  }

  disconnect() {
    if (this.modal) {
      this.modal.hide()
      this.modal.dispose()
      this.modal = null
    }

    this.cleanupBackdrops()
  }

  markAsShown() {
    const expires = new Date()
    expires.setDate(expires.getDate() + 180)

    document.cookie = `${this.cookieKeyValue}=1; expires=${expires.toUTCString()}; path=/; SameSite=Lax`
  }

  cookieExists() {
    return document.cookie
      .split("; ")
      .some((item) => item.startsWith(`${this.cookieKeyValue}=`))
  }

  cleanupBackdrops() {
    // Turbo 遷移後に backdrop が残るのを防ぐ
    document.querySelectorAll(".modal-backdrop").forEach((element) => element.remove())
    document.body.classList.remove("modal-open")
    document.body.style.removeProperty("padding-right")
  }
}
